<template>
  <v-dialog v-model="dialogDelete" max-width="500px">
    <DeleteCard
      v-if="!blockedMessage"
      title="Doriți să ștergeți acest echipament?"
      @cancel="cancelDelete"
      @confirm="confirmDelete"
    />
    <!-- an item with requests or transfers stays for the record: offer to switch it off instead -->
    <v-card v-else width="480px" class="confirm">
      <div class="confirm__icon" aria-hidden="true"><v-icon>mdi-history</v-icon></div>
      <p class="confirm__title">Echipamentul nu poate fi șters</p>
      <p class="confirm__text">{{ blockedMessage }}</p>
      <div class="confirm__actions">
        <v-btn text large @click="cancelDelete">Închide</v-btn>
        <v-btn v-if="canDeactivate" class="btn-green" large :loading="working" @click="deactivate">
          <v-icon left>mdi-power-plug-off-outline</v-icon>Marchează «Este activ: Nu»
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import * as api from "./api";
import DeleteCard from "@/components/elements/DeleteCard.vue";

export default {
  props: {
    equipment: Object,
  },
  components: {
    DeleteCard,
  },
  data() {
    return {
      dialogDelete: false,
      blockedMessage: "",
      working: false,
    };
  },
  computed: {
    canDeactivate() {
      return !!this.equipment && this.equipment.isFunctional !== false;
    },
  },
  methods: {
    show() {
      this.blockedMessage = "";
      this.dialogDelete = true;
    },
    cancelDelete() {
      this.dialogDelete = false;
    },
    async confirmDelete() {
      try {
        await api.deleteEquipment(this.equipment.id);
        this.$emit("updateEquipmentData");
        this.$emit("success", "Echipamentul a fost șters");
        this.dialogDelete = false;
      } catch (error) {
        console.error("Error deleting equipment:", error);
        if (error.response && error.response.status === 409) {
          this.blockedMessage = error.response.data.message;
          return;
        }
        this.dialogDelete = false;
        this.$emit("error", error);
      }
    },
    async deactivate() {
      this.working = true;
      try {
        await api.updateEquipment({ id: this.equipment.id, isFunctional: false });
        this.$emit("updateEquipmentData");
        this.$emit("success", "Echipamentul a fost marcat inactiv");
        this.dialogDelete = false;
      } catch (error) {
        console.error("Error deactivating equipment:", error);
        this.$emit("error", error);
      } finally {
        this.working = false;
      }
    },
  },
};
</script>

<style scoped>
.confirm {
  padding: 26px 26px 20px;
}
.confirm__icon .v-icon {
  font-size: 40px;
  color: var(--amber);
}
.confirm__title {
  margin: 10px 0 8px;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 1.35rem;
  line-height: 1.3;
  color: var(--ink);
}
.confirm__text {
  margin: 0 0 22px;
  color: var(--ink-2);
}
.confirm__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}
</style>
